import React from 'react';
import BtFooterLogo from '../library/Logo/BtFooterLogo';

const Footer: React.FC = () => {
  const clientVersion = process.env.REACT_APP_VERSION ?? '0.0.0';
  const DisplayableClientVersion = String('v' + clientVersion);
  return (
    <div className="h-28 w-full min-h-fit flex items-end bg-black pl-4 pb-2 z-40">
      <div className="w-full h-fit flex flex-col md:flex-row md:items-center pb-2">
        <div className="flex items-center gap-2">
          <BtFooterLogo />
          <p className="text-white">©BT 2026</p>
        </div>
        <p className="text-white md:ml-40">{DisplayableClientVersion}</p>
      </div>
    </div>
  );
};

export default Footer;
